import { isSameMonth } from './isSameMonth'
import dayjs from "dayjs";

export function isSameDate(date: Date, comparison: Date) {
    const jalaliDate1 = dayjs(date).calendar('jalali');
    const jalaliDate2 = dayjs(comparison).calendar('jalali');

    return jalaliDate1.isSame(jalaliDate2, 'date')
    // return (
    //     isSameMonth(date, comparison) && date?.getDate() === comparison?.getDate()
    // )
}
